<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header">
          <h3>가입자</h3>
        </div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              <label for="">가입자명</label>
            </dt>
            <dd class="field-control">
              <input
                v-model="retrieveData.custName"
                ref="custName"
                readonly=true
                class="input-text input-font input-width-medium"
              />
              <!---가입자명은 인증정보가지고 자동입력 해주는 것 같은-->
            </dd>
          </dl>

          <dl class="field-group">
            <dt class="field-label">
              <label for="">연락처</label>
            </dt>
            <dd class="field-control">
              <input
                v-model="retrieveData.custTel"
                ref="custTel"
                name="custTel"
                @input="onlyNumber"
                autocomplete="off"
                class="input-text input-font input-width-medium"
                maxlength="11"
                type="text"
                placeholder="'-' 없이 숫자만 입력"
                title="가입자의 연락처 숫자만 입력"
              />
            </dd>
          </dl>

          <dl class="field-group">
            <dt class="field-label">
              <label for="">휴대폰</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub m-input-half">
                <input
                  v-model="retrieveData.custTelSMS"
                  ref="custTelSMS"
                  name="custTelSMS"
                  @input="onlyNumber"
                  autocomplete="off"
                  class="input-text input-font input-width-medium"
                  size="11"
                  maxlength="11"
                  type="text"
                  placeholder="'-' 없이 숫자만 입력"
                  title="가입자의 연락처 숫자만 입력"
                  v-bind:readonly="this.$store.state.connectedCar.common.onetAutnMthdDivsCd == 'M'"
                />
                <span class="field-group-space"></span>
                <button @click="getVerificationNumber">인증번호발송</button>
              </div>
              <div class="field-control-sub m-input-half">
                <input
                  v-model="retrieveData.authNum"
                  name="authNum"
                  type="text"
                  maxlength="6"
                  @input="onlyNumber"
                  autocomplete="off"
                  class="input-text input-font input-width-xsmall"
                  placeholder="'인증번호입력"
                  title="인증번호 입력"
                />
                <span class="field-group-space"></span>
                <button @click="hpVerification">인증하기</button>
              </div>
              <!-- C20220602_27928_4527928 토요타향 온라인 가입페이지 내 약관 수정에 따른 문구 수정 요청의 건-->
              <div class="field-control-sub"  v-if="(this.$store.state.connectedCar.common.imei+'').length < 1 && this.entrLoc == ''">
                <ul class="notice-text-list">
                  <li class="notice-text">
                    등록하신 휴대폰 번호로 가입하신 요금제의 LTE사용량 알림
                    문자가 발송됩니다. (기본 제공량의 80%, 90% 100%)
                  </li>
                  <li class="notice-text">
                    요금제 기본 제공량 소진 후 추가 사용을 원하실 경우, LTE 가입
                    후 고객센터 (1544-0010)으로 문의 주시기바랍니다.
                  </li>
                </ul>
              </div>
            </dd>
          </dl>

          <dl class="field-group">
            <dt class="field-label">
              <label for="">주민등록번호</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub m-input-half">
                <span>
                  <input
                    type="text"
                    name="custSSN1"
                    ref="custSSN1"
                    readonly=true
                    v-model="retrieveData.custSSN1"
                    @input="onlyNumber"
                    class="input-text input-width-xsmall input-font"
                    maxlength="6"
                    placeholder="앞 6자리"
                    title="가입자 주민등록번호 앞 여섯자리"
                  />
                </span>
                <span class="field-group-space">-</span>
                <span>
                  <input
                    type="password"
                    name="custSSN2"
                    ref="custSSN2"
                    v-model="retrieveData.custSSN2"
                    @input="onlyNumber"
                    class="input-text input-width-xsmall input-font"
                    maxlength="7"
                    placeholder="뒤 7자리"
                    title="가입자 주민등록번호 뒤 일곱자리"
                  />
                </span>
              </div>
            </dd>
          </dl>

          <dl class="field-group">
            <dt class="field-label">
              <label for="">신분증 진위확인정보</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <select
                  v-model="retrieveData.inqDvCd1"
                  name="customer-validation-method"
                  class="input-width-small"
                >
                  <option value="">선택</option>
                  <option
                    v-for="item in regList"
                    :value="item.cmmCdv"
                    :key="item.cmmCdv"
                    >{{ item.cmmCdvNm }}</option
                  >
                  <!-- <template v-if="custType === 'A'">
                    <option value='NAMEC'>주민등록번호/성명확인</option> 
                  </template>
                  <template v-else>
                    <option value='DRIVE'>주민등록증</option> 
                    <option value='NAMEC'>운전면허번호</option> 
                    <option value='REGID'>대한민국여권</option>                   
                    <option value='HANDI'>장애인등록증</option>                   
                    <option value='MERIT'>국가유공자(10종)</option>                                     
                  </template> -->
                </select>
              </div>
              <!--- 주민등록증 -->
              <div
                v-if="retrieveData.inqDvCd1 === 'REGID'"
                class="field-control-sub"
              >
                <label for="" class="input-sub-text">발급일자</label>
                <input
                  v-model="retrieveData.isuDt"
                  type="text"
                  @input="onlyNumber"
                  name="issued-date"
                  class="input-text input-font"
                  maxlength="8"
                  placeholder="예) 20110809"
                  title="주민등록증 발급일자 여덟자리 입력"
                />
              </div>

              <!--- 운전면허번호 -->
              <div
                v-if="retrieveData.inqDvCd1 === 'DRIVE'"
                class="field-control-sub"
              >
               <div class="field-control-sub">
                 <ul class="notice-text-list">
                  <li>
                 운전면허 번호 입력 방법(예시)<br/>
                 면허번호가 <br/>
                 서울 12-123456-12일 경우: 서울(11)을 선택하시고 나머지 숫자를 “-”제외한 10자리 숫자를 입력<br/>
                 11-12-123456-12일 경우: 서울(11)을 선택하시고 나머지 숫자를 “-”제외한 10자리 숫자를 입력
                  </li>
                  <li class="notice-text">
                 운전면허의 앞에 2자리 번호는 최초 발급지역 번호 입니다.
                  </li>
                 </ul>
              </div>
                <div class="field-control-sub">
                  <select
                    v-model="retrieveData.drvLcnsIsuAreaCd"
                    name="regions"
                    title="운전면허 지역선택"
                  >
                    <option value="">지역</option>
                    <option
                      v-for="item in drvList"
                      :value="item.cmmCdv"
                      :key="item.cmmCdv"
                      >{{ item.cmmCdvNm }}</option
                    >
                  </select>
                  <label for="" class="input-sub-text">운전면허번호</label>
                  <input
                    v-model="retrieveData.drvLcnsNo"
                    placeholder='"-" 제외한 10자리 숫자 입력'
                    maxlength="10"
                    type="text"
                    @input="onlyNumber"
                    name="license-number"
                    class="input-text input-font"
                    title="운전면허번호 열 자리 입력"
                  />
                  <span v-if="!this.drvLcnsChk" class="primary-text">※운전면허번호 입력 방법(예시)을 확인해 주세요</span>
                </div>
                <div class="field-control-sub">
                  <label for="" class="input-sub-text">발급일자</label>
                  <input
                    v-model="retrieveData.isuDt"
                    maxlength="8"
                    type="text"
                    @input="onlyNumber"
                    name="issued-date"
                    class="input-text input-font"
                    placeholder="예) 20110809"
                    title="운전면허 발급일자 여덟자리 입력"
                  />
                </div>
              </div>

              <!--- 국가유공자 -->
              <div
                v-if="retrieveData.inqDvCd1 === 'MERIT'"
                class="field-control-sub"
              >
                <div class="field-control-sub">
                  <label for="" class="input-sub-text">보훈번호 </label>
                  <input
                    v-model="retrieveData.monmCsntNo"
                    type="text"
                    @input="onlyNumber"
                    maxlength="10"
                    name="license-number"
                    class="input-text input-font"
                    placeholder="'-'없이 입력하세요"
                    title="보훈번호 열 자리 숫자 입력"
                  />
                  <label for="" class="input-sub-text">발급일자</label>
                  <input
                    v-model="retrieveData.isuDt"
                    name="issued-date"
                    class="input-text input-font"
                    placeholder="20110809"
                    title="보훈번호 발급일자 여덟자리 입력"
                  />
                </div>
              </div>

              <!--- 장애인등록증 -->
              <div
                v-if="retrieveData.inqDvCd1 === 'HANDI'"
                class="field-control-sub"
              >
                <label for="" class="input-sub-text">발급일자</label>
                <input
                  type="text"
                  @input="onlyNumber"
                  v-model="retrieveData.isuDt"
                  class="input-text input-font"
                  maxlength="8"
                  placeholder="예) 20110809"
                  title="장애인등록증 발급일자 여덟자리 입력"
                />
              </div>

              <!--- 외국인등록번호 -->
              <div
                v-if="retrieveData.inqDvCd1 === 'FORGN'"
                class="field-control-sub"
              >
                <label for="" class="input-sub-text">발급일자</label>
                <input
                  type="text"
                  @input="onlyNumber"
                  v-model="retrieveData.isuDt"
                  class="input-text input-font"
                  maxlength="8"
                  placeholder="ex) 20110809"
                  title="외국인등록번호 발급일자 여덟자리 입력"
                />
              </div>

              <!--- 대한민국 여권은 별도 입력없음 -->
            </dd>
          </dl>

          <dl class="field-group">
            <dt class="field-label">
              <label>고객주소</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <div class="input-container input-horizontal">
                  <input
                    id="radio-01-01"
                    v-model="retrieveData.chargeType"
                    type="radio"
                    name="address-type"
                    value="H"
                    class="input-radio"
                    title="가입자 주소 선택"
                  />
                  <label for="radio-01-01" class="input-label">자택</label>
                </div>
                <div class="input-container input-horizontal">
                  <input
                    id="radio-01-02"
                    v-model="retrieveData.chargeType"
                    type="radio"
                    name="address-type"
                    value="O"
                    class="input-radio"
                    title="가입자 주소 선택"
                  />
                  <label for="radio-01-02" class="input-label">직장</label>
                </div>
                <div class="input-container input-horizontal">
                  <input
                    id="radio-01-03"
                    v-model="retrieveData.chargeType"
                    type="radio"
                    name="address-type"
                    value="E"
                    class="input-radio"
                    title="가입자 주소 선택"
                  />
                  <label for="radio-01-03" class="input-label">기타</label>
                </div>
              </div>
              <div class="field-control-sub m-input-half">
                <input
                  type="text"
                  @input="onlyNumber"
                  v-model="retrieveData.chargePost"
                  name="postCode"
                  class="input-text input-width-xsmall input-font input-text-disabled"
                  placeholder="우편번호"
                  readonly
                  title="우편번호"
                />
                <span class="field-group-space"></span>
                <button
                  @click="zipcodeAddressPop"
                  title="새창열림"
                  type="button"
                  ref="zipcodeAddressPop"
                  name="search"
                >
                  주소찾기
                </button>
              </div>

              <div class="field-control-sub">
                <input
                  type="text"
                  @input="onlyText"
                  v-model="retrieveData.chargeAddr1"
                  name="chargeAddr1"
                  class="input-text input-width-xlarge input-font input-text-disabled"
                  readonly
                  tite="가입자 기본주소"
                />
              </div>
              <div class="field-control-sub">
                <input
                  type="text"
                  @input="onlyText"
                  v-model="retrieveData.chargeAddr2"
                  name="chargeAddr2"
                  class="input-text input-width-xlarge input-font input-text-disabled"
                  readonly
                  title="가입자 상세주소"
                />
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              <label>E-Mail</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <div>
                  <span class="m-input-half">
                    <input
                      type="text"
                      @input="onlyText"
                      name="custEmail1"
                      v-model="retrieveData.custEmail1"
                      placeholder="email ID 입력"
                      class="input-text input-width-small input-font"
                      title="이메일 아이디 입력"
                    />
                    <span class="field-group-space">@</span>
                    <select
                      v-model="retrieveData.custEmail22"
                      class="input-width-xsmall"
                      title="이메일 도메인 선택"
                      @change="emailSelect"
                    >
                      <option value="" selected>직접입력</option>
                      <option value="gmail.com">지메일</option>
                      <option value="naver.com">네이버</option>
                      <option value="daum.net">다음(한메일)</option>
                      <option value="nate.com">네이트</option>
                      <option value="dreamwiz.com">드림위즈</option>
                      <option value="hotmail.com">핫메일</option>
                    </select>
                  </span>
                  <span class="m-input-half">
                    <input
                      type="text"
                      @input="onlyText"
                      v-model="retrieveData.custEmail2"
                      name="custEmail2"
                      class="input-text input-width-small input-font"
                      title="이메일 도메인 직접입력"
                    />
                    <button @click="validEmail">확인</button>
                  </span>
                </div>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="registration-page-container">
      <div v-if="payYn === 'Y' || entrLoc === 'B'" class="section">
        <div class="section-header">
          <h3>납부정보</h3>
        </div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              출금결제동의
            </dt>
            <dd class="field-control">
              <div class="input-container">
                <input
                        id="check-pay-agreement"
                        type="checkbox"
                        v-model="retrieveData.payAgreeYnChk"
                        class="input-checkbox input-text"
                        title="출금결제동의여부"
                />
                <label for="check-pay-agreement" class="input-label"
                  ><em class="primary-text">(필수)</em> 동의</label>
              </div>
              <ul class="notice-text-list">
                <li class="notice-text">
                  본인(예금주 또는 회원)이 납부하여야 할 요금에 대해 별도의 통지
                  없이 상기 본인의 지정계좌(카드번호)에서 지정된 송금(결제)일에
                  인출(결재) 하여 주시기 바랍니다.
                </li>
              </ul>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              요금납부
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <div
                  id="radio-button-container-pay-info-bank"
                  class="input-container input-horizontal"
                >
                  <input
                    id="radio-02-01"
                    type="radio"
                    v-model="retrieveData.payType"
                    name="pay-info"
                    @change="clearCardInfo"
                    value="B"
                    class="input-radio"
                    title="요금납부방법선택"
                  />
                  <label for="radio-02-01" class="input-label">은행</label>
                </div>
                <div
                  id="radio-button-container-pay-info-card"
                  class="input-container input-horizontal"
                >
                  <input
                    id="radio-02-02"
                    type="radio"
                    v-model="retrieveData.payType"
                    name="pay-info"
                    @change="clearCardInfo"
                    value="C"
                    class="input-radio"
                    title="요금납부방법선택"
                  />
                  <label for="radio-02-02" class="input-label">카드</label>
                </div>
                  <!--- 미납발행가능으로 토요타일경우 지로 막음 커넥티드카 김정균 요청 2021.06.25 장희정 -->
                 <!-- <div  v-if="entrLoc === 'B'"
                   id="radio-button-container-pay-info-giro"
                   class="input-container input-horizontal"
                 >
                   <input
                     id="radio-02-03"
                     type="radio"
                     v-model="retrieveData.payType"
                     name="pay-info"
                     @change="clearCardInfo"
                     value="G"
                     class="input-radio"
                     title="요금납부방법선택"
                   />
                   <label for="radio-02-03" class="input-label">지로</label>
                 </div> -->
                
              </div>
              <!--- 은행 선택 시-->
              <div
                v-if="retrieveData.payType === 'B'"
                class="field-control-sub"
              >
                <dl class="field-control-sub sub-form">
                  <dt><label class="input-sub-text w120 mw100">은행</label></dt>
                  <dd>
                    <select
                      v-model="retrieveData.selBank"
                      @change="selBankChange('B')"
                      class="input-width-medium"
                      title="납부가능한 은행명 선택"
                    >
                      <option value="000">선택해주세요</option>
                      <option
                        v-for="item in bankList"
                        :value="item.cmmCdv"
                        :key="item.cmmCdv"
                        >{{ item.cmmCdvNm }}</option
                      >
                    </select>
                  </dd>
                </dl>
                <dl class="field-control-sub sub-form">
                  <dt>
                    <label class="input-sub-text w120 mw100">계좌번호</label>
                  </dt>
                  <dd>
                    <input
                      v-model="retrieveData.bankAccount"
                      name="bankAccount"
                      @input="onlyNumber"
                      type="text"
                      size="15"
                      maxlength="20"
                      autocomplete="off"
                      placeholder="'-' 없이 입력하세요"
                      class="input-text input-width-medium input-font "
                      title="납부가능한 계좌번호입력"
                    />
                  </dd>
                  <div class="field-control-sub">
                    <div class="m-input-half">
                      <button
                        @click="validPayment('CM')"
                        class="m-right m-input-half-sub"
                      >
                        인증하기
                      </button>
                    </div>
                  </div>
                </dl>
              </div>
              <!--- 카드 선택 시-->
              <div
                v-if="retrieveData.payType === 'C'"
                class="field-control-sub"
              >
                <dl class="field-control-sub sub-form">
                  <dt>
                    <label
                      for="pay-select-cardname"
                      class="input-sub-text w120 mw100"
                      >카드사</label
                    >
                  </dt>
                  <dd>
                    <select
                      v-model="retrieveData.selBank"
                      @change="selBankChange('C')"
                      title="납부 가능한 카드사선택"
                      class="input-width-medium"
                    >
                      <option value="000">선택해주세요</option>
                      <option
                        v-for="item in cardList"
                        :value="item.cmmCdv"
                        :key="item.cmmCdv"
                        >{{ item.cmmCdvNm }}</option
                      >
                    </select>
                  </dd>
                </dl>
                <dl class="field-control-sub sub-form">
                  <dt>
                    <label class="input-sub-text w120 mw100">카드번호</label>
                  </dt>
                  <dd>
                    <input
                      type="text"
                      name="lgdPan"
                      v-model="retrieveData.bankAccount"
                      @input="onlyNumber"
                      placeholder="'-' 없이 입력하세요"
                      autocomplete="off"
                      class="input-text input-width-medium input-font "
                      title="납부 가능한 카드번호 입력"
                      maxlength="16"
                    />
                  </dd>
                </dl>
                <dl class="field-control-sub sub-form">
                  <dt>
                    <label class="input-sub-text w120 mw100"
                      >유효기간(년/월)</label
                    >
                  </dt>
                  <dd class="m-input-half">
                    <dl class="m-input-half-sub">
                      <dt>
                        <label
                          for="verification-card-expired-year"
                          class="input-sub-text blind"
                          >년</label
                        >
                      </dt>
                      <dd>
                        <select
                          id="verification-card-expired-year"
                          v-model="retrieveData.lgdExpyear"
                          class="input-width-xsmall mw100"
                          title="본인인증 가능한 신용카드의 유효기간 년 선택"
                        >
                          <option
                            v-for="year in yearList"
                            :value="year"
                            :key="year"
                            >{{ year }}</option
                          >
                        </select>
                      </dd>
                    </dl>
                    <span class="field-group-space">/</span>
                    <dl class="m-input-half-sub">
                      <dt>
                        <label
                          for="verification-card-expired-month"
                          class="input-sub-text blind"
                          title="본인인증 가능한 신용카드의 유효기간 월 선택"
                          >월</label
                        >
                      </dt>
                      <dd>
                        <select
                          id="verification-card-expired-month"
                          v-model="retrieveData.lgdExpmon"
                          class="input-width-xsmall mw100"
                        >
                          <option
                            v-for="month in monthList"
                            :value="month"
                            :key="month"
                            >{{ month }}</option
                          >
                        </select>
                      </dd>
                    </dl>
                  </dd>
                </dl>
                <div class="field-control-sub">
                  <div class="m-input-half">
                    <button
                      @click="validPayment('CC')"
                      class="m-right m-input-half-sub"
                    >
                      인증하기
                    </button>
                  </div>
                </div>
              </div>
            </dd>
          </dl>
          <!--- 지로 선택은 상세 없음-->
          <!--- 이 섹션의 청구서 선택은 신규에서만 나오는 것으로 보여짐 -->
          <dl class="field-group">
            <dt class="field-label">
              <label>청구서 수령방법 선택</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <div class="input-container input-horizontal">
                  <input
                    id="radio-03-01"
                    type="radio"
                    name="bill-type"
                    v-model="retrieveData.chargeSendType"
                    value="2"
                    class="input-radio"
                    title="청구서 수령방법 선택"
                  />
                  <label for="radio-03-01" class="input-label"
                    >E-MAIL(청구서 내용 상세)</label
                  >
                </div>
                <div class="input-container input-horizontal">
                  <input
                    id="radio-03-02"
                    type="radio"
                    name="bill-type"
                    v-model="retrieveData.chargeSendType"
                    value="5"
                    class="input-radio"
                    title="청구서 수령방법 선택"
                  />
                  <label for="radio-03-02" class="input-label"
                    >휴대폰(청구서 내용 간편)</label
                  >
                </div>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <ZipcodeDirectPopup @close="popupClose" />
    <v-dialog />
  </div>
</template>

<script>
import ZipcodeDirectPopup from '../../openMarket/popup/ZipcodeDirectPopup'
import {
  smsAuthCheck,
  smsAuthSendConnctedCar,
  commCode,
  validAccount,
  getBlEmailBlock,
  retrieveDateList
} from '@/api/common'
export default {
  name: 'ConnectedCarCustomerSection',
  props: {},
  components: {
    ZipcodeDirectPopup
  },
  data() {
    return {
      retrieveData: {
        custName: '', // 고객 이름
        custTel: '', // 연락처
        custTelSMS: '', // 핸드폰번호
        authNum: '', // 인증번호
        custSSN1: '', // 주민번호앞자리 6자리
        custSSN2: '', // 주민번호뒷자리 7자리
        inqDvCd1: '', // 신분증진위 여부 구분 코드
        isuDt: '', // 주민등록증 등록 날짜
        monmCsntNo: '',
        drvLcnsNo: '', // 운전면허 번호
        chargeType: '', // 주소 구분
        chargePost: '', // 우편번호
        chargeAddr1: '', // 주소1
        chargeAddr2: '', // 주소2
        custEmail1: '', // email id
        custEmail2: '', // email domain
        custEmail22: '', // 선택한 도메인
        billEmailAddr: '',
        drvLcnsIsuAreaCd: '',
        payAgreeYnChk: false, // 출금결제 동의 여부
        payType: '',
        selBank: '000',
        selBankName: '',
        bankAccount: '',
        lgdExpyear: '', // 카드유효년도
        lgdExpmon: '', // 카드유효개월
        chargeSendType: '' // 청구 구분
      },
        custType: '',
        smsConfirm: false,
        emailConfirm: false,
        accountConfirm: false,// 계좌 또는 카드인증 장희정 추가 2022.06.22
        drvList: [],
        regList: [],
        cardList: [],
        bankList: [],
        yearList: [],
        monthList: [],
        payYn: 'N',
        imei: '',
        uplusUser: {zipCd: '', addr1: '', addr2: '', emailAddr: ''},  // C20210705_43508_4443508 by heejung0102
        drvLcnsChk:true,
        entrLoc: ''
    }
  },
  computed: {},
  mounted() {
    // 초기 값 세팅
    this.entrLoc = this.$store.state.connectedCar.common.entrLoc
    this.payYn = this.$store.state.connectedCar.common.payYn
    this.retrieveData.custName = this.$store.state.connectedCar.personalInfo.name
    this.retrieveData.custTelSMS = this.$store.state.connectedCar.personalInfo.phoneNo
      this.retrieveData.custSSN1 = this.$store.state.connectedCar.personalInfo.birthDay
      this.imei = this.$store.state.connectedCar.common.imei
      commCode('G116').then(res => {
          this.regList = res.data
      })
    commCode('DRV_LCNS_ISUE_AREA_CD').then(res => {
      this.drvList = res.data
    })
    // 은행 구분 리스트 조회
    commCode('G125').then(res => {
      this.bankList = res.data
    })
    // 계좌 구분 리스트 조회
    commCode('G126').then(res => {
      this.cardList = res.data
    })
    // 년도 조회
    this.yearList = retrieveDateList("year")
    this.retrieveData.lgdExpyear = this.yearList[0]
    // 월 조회
    this.monthList = retrieveDateList("month")
    this.retrieveData.lgdExpmon = this.monthList[0]
  },
  methods: {
    /** 
     * Function    : validCustomer
     * Description : 가입자정보 필수값 Validation
     **/
    validCustomer() {
      let title = '가입자정보'
      if (!this.retrieveData.custName) {
        this.$refs.custName.focus()
        this.openAlert(title, '가입자명을 입력하세요')
        return false
      }
      if (!this.retrieveData.custTel) {
        this.$refs.custTel.focus()
        this.openAlert(title, '연락처를 입력하세요')
        return false
      }
      if (!this.retrieveData.custTelSMS) {
        this.$refs.custTelSMS.focus()
        this.openAlert(title, '휴대폰을 입력하세요')
        return false
      }
      let regExpNm = /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|A-Z|0-9|\s]+$/
      if (!regExpNm.test(this.retrieveData.custName)) {
        this.openAlert(title, '이름은 한글, 영어, 숫자만 입력 가능합니다.')
        return false
      }
      if (!this.retrieveData.custSSN1) {
        this.$refs.custSSN1.focus()
        this.openAlert(title, '주민번호 앞자리를 입력해주세요.')
        return false
      }
      let regExpSsn1 = /^[0-9]{6}$/
      if (!regExpSsn1.test(this.retrieveData.custSSN1)) {
        this.openAlert(title, '주민번호 앞자리는 6자리 숫자를 입력해주세요.')
        return false
      }
      if (!this.retrieveData.custSSN2) {
        this.$refs.custSSN2.focus()
        this.openAlert(title, '주민번호 뒷자리를 입력해주세요.')
        return false
      }
      let regExpSsn2 = /^[0-9]{7}$/
      if (!regExpSsn2.test(this.retrieveData.custSSN2)) {
        this.openAlert(title, '주민번호 뒷자리는 7자리 숫자를 입력해주세요.')
        return false
      }
      let ssn2 = this.retrieveData.custSSN2
      if(ssn2.substr(0,1) === '5' || ssn2.substr(0,1) === '6' || ssn2.substr(0,1) === '7' || ssn2.substr(0,1) === '8') {
        if (this.retrieveData.inqDvCd1 !== 'FORGN') {
          this.openAlert(title, '외국인일 경우 외국인등록번호로 선택해주세요.')
          return false
        }
      }
      else if(ssn2.substr(0,1) === '1' || ssn2.substr(0,1) === '2' || ssn2.substr(0,1) === '3' || ssn2.substr(0,1) === '4' || ssn2.substr(0,1) === '0' || ssn2.substr(0,1) === '9') {
        if (this.retrieveData.inqDvCd1 === 'FORGN') {
          this.openAlert(title, '내국인일 경우 외국인등록번호 외 다른 진위확인정보를 선택해주세요.')
          return false
        }
      }
      else {
        this.openAlert(title, '주민번호 뒷자리를 다시 확인해주세요.')
        return false
      }

      if (!this.retrieveData.inqDvCd1) {
        this.openAlert(title, '신분증 진위확인정보를 입력하세요')
        return false
      }
      
      if (this.retrieveData.inqDvCd1 === 'DRIVE') {
        // 운전면허번호
        if (!this.retrieveData.drvLcnsIsuAreaCd) {
          this.openAlert(title, '운전면허 지역선택을 입력하세요')
          this.drvLcnsChk=false
          return false
        }
        if (!this.retrieveData.drvLcnsNo) {
          this.openAlert(title, '운전면허번호를 입력하세요')
           this.drvLcnsChk=false
          return false
        }
        let regExpNo = /^[0-9]{10}$/
        if (!regExpNo.test(this.retrieveData.drvLcnsNo)) {
          this.openAlert(title, '운전면허번호는 10자리 숫자를 입력해주세요.')
           this.drvLcnsChk=false
          return false
        }
         this.drvLcnsChk=true
      }else{
        this.retrieveData.drvLcnsIsuAreaCd="";
        this.retrieveData.drvLcnsNo="";

      }

      if (this.retrieveData.inqDvCd1 !== 'NAMEC') {
        // 여권이 아닌 경우
        if (!this.retrieveData.isuDt) {
          this.openAlert(title, '발급일자를 입력하세요')
          return false
        }
      }

      if (this.retrieveData.inqDvCd1 === 'MERIT') {
        // 국가유공자
        if (!this.retrieveData.monmCsntNo) {
          this.openAlert(title, '보훈번호를 입력하세요')
          return false
        }
      }
      if (!this.retrieveData.chargeType) {
        this.openAlert(title, '고객주소구분을 선택하세요')
        return false
      }
      if (!this.retrieveData.chargeAddr1) {
        this.openAlert(title, '고객주소를 입력하세요')
        return false
      }
      if (!this.retrieveData.chargeAddr2) {
        this.openAlert(title, '고객상세주소를 입력하세요')
        return false
      }
      if (!this.retrieveData.custEmail1) {
        this.openAlert(title, 'E-MAIL ID를 입력하세요')
        return false
      }
      if (!this.retrieveData.custEmail2) {
        this.openAlert(title, 'E-MAIL 도메인을 입력하세요')
        return false
      }
      if (this.payYn === 'Y' || this.entrLoc === 'B') {// 중고일 경우 체크로직 추가

        if(!this.retrieveData.payAgreeYnChk){
          this.openAlert(title, '출금결제동의를 해주세요')
          return false
        }
        if (!this.retrieveData.payType) {
          this.openAlert(title, '요금납부 방법을 선택해주세요')
          return false

        }else if (this.retrieveData.payType && this.retrieveData.selBank ==='000' && this.entrLoc !== 'B') {
          this.openAlert(title, '은행 또는 카드사를 선택해주세요')
          return false

        }
        if(!this.accountConfirm && this.entrLoc !== 'B'){
          this.openAlert(title, '계좌번호 또는 카드번호 인증을 해주세요')
           return false
        }

        if (!this.retrieveData.chargeSendType) {
          this.openAlert(title, '청구서수령방법을 선택해주세요')
          return false
        }
      }

      return true
    },

    /** 
     * Function    : onlyNumber
     * Description : input값 숫자 체크
     **/
    onlyNumber(e) {
      this.retrieveData[e.target.name] = e.target.value.replace(/[^0-9]/gi, '')
    },

    /** 
     * Function    : onlyText
     * Description : input값 텍스트 체크
     **/
    onlyText(e) {
      this.retrieveData[e.target.name] = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
    },

    /** 
     * Function    : zipcodeAddressPop
     * Description : 우편번호 조회 팝업 호출
     **/
    zipcodeAddressPop() {
      this.$store.state.zipType = 'customer'
      this.$modal.show('zipcodeAddress')
    },

    /** 
     * Function    : emailSelect
     * Description : 이메일 select box 선택 이벤트
     **/
    emailSelect(event) {
      this.retrieveData.custEmail2 = event.target.value
    },

    /** 
     * Function    : validEmail
     * Description : 이메일 인증 검사 함수
     **/
    validEmail() {
      if (this.checkEmail()) {
        let title = '이메일 인증'
        let message = ''
        // RetrieveBlEmailBlock.uplus API를 호출하여 처리
        let billEmailAddr = `${this.retrieveData.custEmail1}@${this.retrieveData.custEmail2}`
        if (billEmailAddr.length > 50) {
          this.openAlert(
            title,
            '허용된 이메일 자릿수를 초과하였습니다.\n다른 이메일로 입력바랍니다.'
          )
          return
        }
        getBlEmailBlock(billEmailAddr).then(res => {
          let blackRegYn = res.data.dsRes.blackRegYn
          let blockCntYn = res.data.dsRes.blockCntYn
          let blockCntYnMsg = res.data.dsRes.blockCntYnMsg
          if (blackRegYn === 'Y') {
            message =
              '등록하신 이메일 주소는 등록이 제한된 이메일 주소 입니다.\n이메일 주소를 확인하시어 다른 이메일 주소로 등록 해주십시오.\n(이메일 주소 이용자가 발송 차단 요청, 타인 이메일 청구서 다량 수신 건으로 등록 차단 요청)'
            this.emailConfirm = false
          } else if (blockCntYn === 'Y') {
            message =blockCntYnMsg
             // '등록하신 이메일 주소는 등록제한 횟수(5건)를 초과한 \n이메일 주소입니다.\n해당 이메일 주소로는 등록이 불가하오니, 다른 이메일 주소를 확인하시어 등록해 주십시오.'
            this.emailConfirm = false
          } else {
            message = '이메일 확인 성공하였습니다!'
            this.retrieveData.billEmailAddr = billEmailAddr
            this.emailConfirm = true
          }
          this.openAlert(title, message)
        })
      }
    },

    /** 
     * Function    : checkEmail
     * Description : 이메일 input값 Validation
     **/
    checkEmail() {
      let emailCheckTitle = '이메일 확인'
      if (!this.retrieveData.custEmail1) {
        this.openAlert(emailCheckTitle, '가입자 email을 입력하세요')
        return false
      }
      if (!this.retrieveData.custEmail2) {
        this.openAlert(emailCheckTitle, '가입자 email을 입력하세요')
        return false
      }
      return true
    },

    /** 
     * Function    : getVerificationNumber
     * Description : 휴대폰 인증 validation 및 인증번호 sms 전송
     **/
    getVerificationNumber() {
      let hpRegx = /^(?:(010\d{4})|(01[1|6|7|8|9]\d{3,4}))(\d{4})$/
      let title = '휴대폰인증'
      if (hpRegx.test(this.retrieveData.custTelSMS) && this.$store.state.connectedCar.common.dealCd && this.retrieveData.custName && this.retrieveData.custSSN1) {
        let param = {
          phoneNo: this.retrieveData.custTelSMS,
          dealCd: this.$store.state.connectedCar.common.dealCd,
          onetMblAppfNo: '',
          lgdBuyer: this.retrieveData.custName,
          lgdPrivateno: this.retrieveData.custSSN1
        }
        smsAuthSendConnctedCar(param)
          .then(res => {
              let resultCd = res.data.dsRsltInfo.rsltCd
              let resultMsg = res.data.dsRes.msg

            if (resultCd === 'SUCCESS') {
                this.$store.state.connectedCar.common.tradeid = res.data.resultData.tradeid;
                this.uplusUser = res.data.resultData; // C20210705_43508_4443508 by heejung0102

                this.openAlert(title, resultMsg)
            } else {
              this.openAlert(title, resultMsg)
            }
          })
          .catch(e => {
            this.openAlert('에러', e.message)
          })
      } else {
        this.openAlert(title, '휴대폰 번호를 확인해 주세요.')
      }
    },

    /** 
     * Function    : hpVerification
     * Description : 입력된 인증번호 검사
     **/
    hpVerification() {
      this.$store.state.connectedCar.common.smsval = this.retrieveData.authNum;
      let title = '휴대폰인증'
      let param = {
        phoneNo: this.retrieveData.custTelSMS,
        dealCd: this.$store.state.connectedCar.common.dealCd,
        onetMblAppfNo: '',
        lgdBuyer: this.retrieveData.custName,
        lgdPrivateno: this.retrieveData.custSSN1,
        smsval: this.retrieveData.authNum,
        tradeid: this.$store.state.connectedCar.common.tradeid
      }
      smsAuthCheck(param).then(res => {
        let resultCd = res.data.dsRsltInfo.rsltCd
        let resultMsg = res.data.dsRes.msg
        if (resultCd === 'SUCCESS') {
            this.verificationCheck = true
            this.smsConfirm = true
            //ST C20210705_43508_4443508 by heejung0102
            if (this.uplusUser.isLgtUser === "Y") {
                this.retrieveData.chargePost = this.uplusUser.zipCd;
                this.retrieveData.chargeAddr1 = this.uplusUser.addr1;
                this.retrieveData.chargeAddr2 = this.uplusUser.addr2;

                if (this.uplusUser.emailAddr) {
                    var custEmail = this.uplusUser.emailAddr.split('@');
                    if (custEmail.length > 1) {
                        this.retrieveData.custEmail1 = custEmail[0];
                        this.retrieveData.custEmail2 = custEmail[1];
                    }
                    this.retrieveData.billEmailAddr == this.uplusUser.emailAddr;
                }
            }//ED C20210705_43508_4443508

            this.openAlert(title, resultMsg)

        } else {
          this.smsConfirm = false
          this.openAlert(title, resultMsg)
         
        }
       // alert(" smsAuthCheck "+this.smsConfirm)
      })
    },

    /** 
     * Function    : popupClose
     * Description : 우편번호 팝업 닫힐 시 이벤트
     **/
    popupClose(result) {
      if (result.id === 'ok') {
        this.retrieveData.chargePost = result.ok.zip
        this.retrieveData.chargeAddr1 = result.ok.addr1
        this.retrieveData.chargeAddr2 = result.ok.addrDetail
      }
      this.$refs.zipcodeAddressPop.focus()
    },

    /** 
     * Function    : regAccount
     * Description : 계좌번호 필수값 Validation
     **/
    regAccount() {
      let title = '계좌번호인증'
      if (!this.retrieveData.selBank) {
        this.openAlert(title, '은행을 선택하세요')
        return false
      }
      if (!this.retrieveData.bankAccount) {
        this.openAlert(title, '계좌번호를 선택하세요')
        return false
      }
      if (!this.checkAccountInfo()) {
        this.openAlert(
          title,
          '해당계좌번호는 자동이체 출금이 되지 않는 계좌입니다.\n자동이체 출금이 가능한 계좌번호를 등록하여 주시기 바랍니다.'
        )
        return false
      }
      return true
    },

    /** 
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message) {
      this.$modal.show('dialog', {
        title: title,
        text: message,
        buttons: [
          {
            title: '확인',
            class: 'primary-button'
          }
        ]
      })
    },

    /** 
     * Function    : checkAccountInfo
     * Description : 계좌번호 input값 validation
     **/
    checkAccountInfo() {
      let cSelBank = this.retrieveData.selBank
      var cBankAccount = this.retrieveData.bankAccount
      let bool = true
      // 기업(003) : 10,11자리계좌 차단 (평생계좌체계)
      if (cSelBank == '003') {
        if (cBankAccount.length == 10 || cBankAccount.length == 11) {
          bool = false
          return false
        }
      }
      // 대구(031) : 10자리 이하 계좌 차단 (평생계좌체계)
      if (cSelBank == '031') {
        if (cBankAccount.length <= 10) {
          bool = false
          return false
        }
      }
      // 신한(088) : 010시작계좌 및 561,562시작계좌(가상계좌)차단
      if (cSelBank == '088') {
        if (
          cBankAccount.substring(0, 3) == '010' ||
          cBankAccount.substring(0, 3) == '561' ||
          cBankAccount.substring(0, 3) == '562'
        ) {
          bool = false
          return false
        }
      }
      //농협중앙회(011)   : 10, 13자리계좌의 마지막 자리 8 차단
      if (cSelBank == '011') {
        if (cBankAccount.length == 10 || cBankAccount.length == 13) {
          if (cBankAccount.charAt(cBankAccount.length - 1) == '8') {
            bool = false
            return false
          }
        }
      }
      // 농협회원조합(012) : 10, 13자리 계좌의 마지막 자리 9 차단
      if (cSelBank == '012') {
        if (cBankAccount.length == 10 || cBankAccount.length == 13) {
          if (cBankAccount.charAt(cBankAccount.length - 1) == '9') {
            bool = false
            return false
          }
        }
      }
      return bool
    },

    /** 
     * Function    : validPayment
     * Description : 계좌/신용카드 인증
     **/
    validPayment(type) {
      var param = {}
      let title = '계좌/신용카드 인증'
      switch (type) {
        // 계좌번호 인증
        case 'CM':
          if (this.regAccount()) {
            // let param = {}
            param.acntOwnrNo = this.retrieveData.custSSN1
            param.pymCustNm = this.retrieveData.custName
            param.bankAcntNo = this.retrieveData.bankAccount
            param.bankCd = this.retrieveData.selBank
            param.pymMthdCd = type
            validAccount(param).then(res => {
              let msgCd = res.data.dsRsltInfo.rsltCd
              let message = res.data.dsRsltInfo.rsltMsg
              this.openAlert(title, message)

              if (msgCd === 'SUCCESS') {
                this.accountConfirm = true
                this.openAlert('계좌번호 인증', '인증성공')
              } else {
                this.accountConfirm = false
                this.openAlert('인증 오류', message)
              }
            })
          } else {
            // 인증 실패시 API를 태우지 않는다.
             this.accountConfirm= false
            return
          }
          break
        // 카드 인증
        case 'CC':
          // let param = {}
          param.acntOwnrNo = this.retrieveData.custSSN1
          param.pymCustNm = this.retrieveData.custName
          param.bankAcntNo = this.retrieveData.bankAccount
          param.bankCd = this.retrieveData.selBank
          param.pymMthdCd = type
          param.cardValdEndYymm =
            this.retrieveData.lgdExpyear + this.retrieveData.lgdExpmon
          validAccount(param).then(res => {
            let msgCd = res.data.dsRsltInfo.rsltCd
            let message = res.data.dsRsltInfo.rsltMsg
             if (msgCd === 'SUCCESS') {
                this.accountConfirm = true
                this.openAlert('카드 인증', '인증성공')
              } else {
                this.accountConfirm = false
                this.openAlert('인증 오류', message)
              }
          })
          break
      }
    },

    /** 
     * Function    : selBankChange
     * Description : 은행사 select box 값 변경시 이벤트
     **/
    selBankChange(type) {
      switch (type) {
        case 'C':
          var selCardList = []
          selCardList = this.cardList.filter(item => {
            return item.cmmCdv === this.retrieveData.selBank
          })
          this.retrieveData.selBankName = selCardList[0].cmmCdvNm
          break
        case 'B':
          var selBankList = []
          selBankList = this.bankList.filter(item => {
            return item.cmmCdv === this.retrieveData.selBank
          })
          this.retrieveData.selBankName = selBankList[0].cmmCdvNm
          break
      }
    },

    /** 
     * Function    : clearCardInfo
     * Description : 카드 정보 초기화
     **/
    clearCardInfo() {
      // 카드 정보 초기화
      this.retrieveData.selBank = '000'
      this.retrieveData.selBankName = ''
      this.retrieveData.bankAccount = ''
      this.retrieveData.lgdExpyear = this.yearList[0]
      this.retrieveData.lgdExpmon = this.monthList[0]
    }
  }
}
</script>

<style scoped></style>
